<section class="pt-12 md:pt-32 pb-20 md:pb-28">
  <div [class]="isLanding ? 'container--landing' : 'px-8'">
    <div
      class="flex flex-wrap md:flex-nowrap justify-between items-start pb-28 border-b border-theme-gray-eight"
    >
      <div class="w-full md:w-auto md:max-w-xl">
        <div class="mb-12 md:mb-24">
          <app-site-logo></app-site-logo>
        </div>

        <div class="font-bold text-14 mb-6 md:mb-14">
          {{ 'landing.application' | translate : { siteName: languageService.siteName } }}
        </div>

        <div class="flex space-x-8">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [href]="languageService.appStoreUrl"
            target="_blank"
            ><img
              src="assets/assets-site/images/landing/app-store-badge.svg"
              [alt]="'landing.disponible_appstore' | translate"
              class="h-16 md:h-20"
          /></a>
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [href]="languageService.googlePlayUrl"
            target="_blank"
            ><img
              src="assets/assets-site/images/landing/google-play-badge.svg"
              [alt]="'landing.disponible_googleplay' | translate"
              class="h-16 md:h-20"
          /></a>
        </div>
      </div>

      <div class="col-links">
        <div class="link-title">
          {{ 'landing.informations' | translate }}
        </div>
        <ul class="links">
          <li>
            <a [routerLink]="['/legal/cgu']">{{ 'cgu.cgu_short' | translate }}</a>
          </li>
          <li *ngIf="!isApplicationService.isAppIos()">
            <a [routerLink]="['/legal/cgv']">{{ 'cgu.vente_short' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="['/legal/mentions']">{{ 'cgu.mentions' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="['/legal/confidentiality']">{{ 'cgu.confidentialite' | translate }}</a>
          </li>
          <li *ngIf="languageService.testimoniesEnabled">
            <a [routerLink]="['/testimonies']">{{
              'livreor.temoignages' | translate : { siteName: languageService.siteName }
            }}</a>
          </li>
        </ul>
      </div>

      <div class="col-links" *ngIf="languageService.intercomHelpdesk">
        <div class="link-title">
          {{ 'landing.support' | translate }}
        </div>
        <ul class="">
          <li>
            <a target="_blank" [href]="languageService.intercomHelpdesk">{{
              'sidebar.faq' | translate
            }}</a>
          </li>
        </ul>
      </div>

      <div class="col-buttons hidden md:block space-y-8">
        <a
          matRipple
          [matRippleCentered]="false"
          [matRippleUnbounded]="true"
          [matRippleRadius]="50"
          [routerLink]="['/user/login']"
          class="btn-nnki btn-nnki-white"
          >{{ 'navbar.main.se_connecter' | translate }}</a
        >
        <a
          matRipple
          [matRippleCentered]="false"
          [matRippleUnbounded]="true"
          [matRippleRadius]="50"
          [routerLink]="['/user/register']"
          class="btn-nnki btn-nnki-primary"
          >{{ 'navbar.main.essai' | translate }}</a
        >
      </div>
    </div>
    <div class="pt-10 text-12">
      &copy; {{ (nowService.now$ | async).getFullYear() }}
      {{ 'landing.ecnifr' | translate : { siteName: languageService.siteName } }}
    </div>
  </div>
</section>
